module.exports = __webpack_public_path__ + "img/Floor002367-img2.93be3d18.jpg";